module.exports = __webpack_public_path__ + "static/media/advanced.2012522c.png";